const payAmountsKeys = [
    'amount',
    'default_regular_amount',
    'default_first_amount',
    'first_amount',
    'regular_amount',
    'refunded_amount',
    'total_subscriptions_regular_amount'
];

function calculateAmountFromBackend(amount) {
    return amount / 100;
};

function calculateAmountToBackend(amount) {
    return amount * 100;
}

function preparePayAmounts(data, toBackEnd) {
    const keys = Object.keys(data);
    keys.forEach(key => {
        if (!isNaN(Number(data[key])) && payAmountsKeys.includes(key)) {
            if (toBackEnd) {
                data[key] = calculateAmountToBackend(data[key]);
            } else {
                data[key] = calculateAmountFromBackend(data[key]);
            }
        }

        if (!!data[key] && typeof data[key] === 'object') {
            if (Array.isArray(data[key])) {
                data[key].forEach((elem) => {
                    if (typeof elem === 'object') {
                        preparePayAmounts(elem);
                    }
                });
            } else {
                preparePayAmounts(data[key]);
            }
        }
    });
};

function preparePayAmountsForBackend(data) {
    preparePayAmounts(data, true);
}

export { preparePayAmounts, preparePayAmountsForBackend };
